/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// ===== Celovia Custom Styles =====
(function() {
  var css = [
    /* Kleinere Größen-Buttons */
    '.block-swatch__item {',
    '  min-width: 38px !important;',
    '  padding: 5px 10px !important;',
    '  font-size: 11px !important;',
    '  line-height: 1 !important;',
    '  display: flex !important;',
    '  align-items: center !important;',
    '  justify-content: center !important;',
    '  text-align: center !important;',
    '}'
  ].join('\n');

  var style = document.createElement('style');
  style.id = 'celovia-custom-styles';
  style.textContent = css;

  function injectStyle() {
    var existing = document.getElementById('celovia-custom-styles');
    if (existing) existing.remove();
    document.head.appendChild(style);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectStyle);
  } else {
    injectStyle();
  }
})();
// ===== Ende Celovia Custom Styles =====

// ===== Celovia color media fallback =====
(function() {
  if (window.__celoviaColorMediaFallbackBound) return;
  window.__celoviaColorMediaFallbackBound = true;

  function mediaSlides(root) {
    var scope = root && root.querySelector ? root : document;
    var slides = Array.prototype.slice.call(scope.querySelectorAll('media-gallery .product__media-item[data-media-id], .product__media-item[data-media-id]'));
    if (!slides.length && scope !== document) {
      slides = Array.prototype.slice.call(document.querySelectorAll('media-gallery .product__media-item[data-media-id], .product__media-item[data-media-id]'));
    }
    return slides;
  }

  function activateSlide(slide) {
    if (!slide) return;

    var mediaId = slide.getAttribute('data-media-id');
    var carousel = slide.closest('flickity-carousel');
    var gallery = slide.closest('media-gallery') || document.querySelector('media-gallery');
    var viewer = gallery ? gallery.querySelector('[id^="GalleryViewer"]') : document.querySelector('[id^="GalleryViewer"]');
    var thumbnail = gallery
      ? gallery.querySelector('[data-target="' + mediaId + '"], [aria-controls="' + slide.id + '"], [data-media-id="' + mediaId + '"]')
      : document.querySelector('[data-target="' + mediaId + '"], [aria-controls="' + slide.id + '"], [data-media-id="' + mediaId + '"]');

    if (gallery && typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(mediaId, false);
    }

    if (carousel && typeof carousel.select === 'function') {
      carousel.select('[data-media-id="' + mediaId + '"]');
      carousel.querySelectorAll('.product__media-item[data-media-id]').forEach(function(item) {
        var isTarget = item === slide;
        item.classList.toggle('is-selected', isTarget);
        item.classList.toggle('is-active', isTarget);
        if (isTarget) {
          item.removeAttribute('aria-hidden');
        } else {
          item.setAttribute('aria-hidden', 'true');
        }
      });
    }

    if (viewer) {
      viewer.querySelectorAll('.product__media-item[data-media-id]').forEach(function(item) {
        item.classList.toggle('is-active', item === slide);
      });

      var scroller = viewer.slider || viewer.querySelector('.product__media-list') || slide.parentElement;
      if (scroller && typeof scroller.scrollTo === 'function') {
        scroller.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      } else {
        slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    if (thumbnail) {
      var thumbnailButton = thumbnail.querySelector('button');
      document.querySelectorAll('[aria-controls][aria-current="true"], [data-media-id][aria-current="true"]').forEach(function(activeThumb) {
        activeThumb.removeAttribute('aria-current');
      });
      if (thumbnailButton) {
        thumbnailButton.setAttribute('aria-current', 'true');
      } else {
        thumbnail.setAttribute('aria-current', 'true');
      }
      if (thumbnail.parentElement && typeof thumbnail.parentElement.scrollTo === 'function') {
        thumbnail.parentElement.scrollTo({ left: thumbnail.offsetLeft, behavior: 'smooth' });
      }
    }
  }

  document.addEventListener('click', function(event) {
    var swatch = event.target.closest && event.target.closest('.caay-color-swatch');
    if (!swatch) return;
    if (swatch.closest('.caay-product-info')) return;

    window.setTimeout(function() {
      var productRoot = swatch.closest('.product, product-info, .shopify-section') || document;
      var swatchRoot = swatch.closest('.caay-color-swatches') || productRoot;
      var swatches = Array.prototype.slice.call(swatchRoot.querySelectorAll('.caay-color-swatch'));
      var index = swatches.indexOf(swatch);
      var slides = mediaSlides(productRoot);

      if (index < 0 || !slides.length || swatches.length < 2) return;

      var slidesPerColor = Math.max(1, Math.ceil(slides.length / swatches.length));
      var targetIndex = index * slidesPerColor;
      targetIndex = Math.max(0, Math.min(slides.length - 1, targetIndex));
      activateSlide(slides[targetIndex]);
    }, 120);
  }, true);
})();
// ===== Ende Celovia color media fallback =====

// ===== Celovia cart refresh timer =====
(function() {
  if (window.__celoviaCartRefreshTimerBound) return;
  window.__celoviaCartRefreshTimerBound = true;

  var duration = 6 * 60 * 1000;
  var storageKey = 'celovia-cart-refresh-end-v1';
  var previousStorageKey = 'celovia-cart-reservation-end';
  var memoryEnd = null;
  var framePending = false;
  var refreshPending = false;

  try {
    window.sessionStorage.removeItem(previousStorageKey);
  } catch (error) {
    // Session storage may be unavailable in strict privacy modes.
  }

  function readStoredEnd() {
    try {
      return Number(window.sessionStorage.getItem(storageKey)) || memoryEnd;
    } catch (error) {
      return memoryEnd;
    }
  }

  function writeStoredEnd(value) {
    memoryEnd = value;
    try {
      window.sessionStorage.setItem(storageKey, String(value));
    } catch (error) {
      // The in-memory value keeps the timer working without session storage.
    }
  }

  function clearStoredEnd() {
    memoryEnd = null;
    try {
      window.sessionStorage.removeItem(storageKey);
    } catch (error) {
      // Nothing else is required when storage is unavailable.
    }
  }

  function refreshEnd() {
    var now = Date.now();
    var end = readStoredEnd();
    if (!end || end > now + duration) {
      end = now + duration;
      writeStoredEnd(end);
    }
    return end;
  }

  function refreshCart() {
    if (refreshPending) return;
    refreshPending = true;
    writeStoredEnd(Date.now() + duration);
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
    window.setTimeout(function() {
      refreshPending = false;
      scheduleTimer();
    }, 1500);
  }

  function renderTimer() {
    framePending = false;
    var drawer = document.getElementById('mini-cart');
    var timers = document.querySelectorAll('[data-celovia-cart-refresh-timer]');
    if (!drawer || !timers.length || !drawer.hasAttribute('open')) return;

    var remaining = refreshEnd() - Date.now();
    if (remaining <= 0) {
      timers.forEach(function(timer) {
        timer.textContent = '00:00';
      });
      refreshCart();
      return;
    }

    var seconds = Math.ceil(remaining / 1000);
    var minutes = Math.floor(seconds / 60);
    var rest = seconds % 60;
    var value = String(minutes).padStart(2, '0') + ':' + String(rest).padStart(2, '0');

    timers.forEach(function(timer) {
      timer.textContent = value;
    });
  }

  function scheduleTimer() {
    if (framePending) return;
    framePending = true;
    window.requestAnimationFrame(renderTimer);
  }

  document.addEventListener('cart:updated', function(event) {
    if (event.detail && event.detail.cart && event.detail.cart.item_count === 0) {
      clearStoredEnd();
    }
    scheduleTimer();
  });

  var observer = new MutationObserver(scheduleTimer);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['open']
  });

  window.setInterval(renderTimer, 1000);
  scheduleTimer();
})();
// ===== Ende Celovia cart refresh timer =====
